import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Perfil } from '../_models/usuario/perfil';
import { Observable , of} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PerfilResponse } from '../_models/response/perfilResponse';


export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};
@Injectable({ providedIn: 'root' })
export class PerfilService {
  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get<Perfil[]>(`${environment.authorizedUrls.bsCobrancaUrl}/perfil`);
  }

  getAllPorPerfil(nmePerfil: string) {
    return this.http.get<Perfil[]>(`${environment.authorizedUrls.bsCobrancaUrl}/perfil/listarPorPerfil/` + nmePerfil);
  }

   inserir(perfil: Perfil): Observable<PerfilResponse> {
    return this.http.post<PerfilResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/perfil/incluir`, {
      perfil
    });
  }

  atualizar(perfil: Perfil): Observable<PerfilResponse> {
     return this.http.post<PerfilResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/perfil/atualizar`, {
      perfil
    });
  }

  deletar(perfil: Perfil): Observable<PerfilResponse> {
    return this.http.post<PerfilResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/perfil/excluir`, {
      perfil
    });
  }
}
